import { find, includes, map } from 'lodash'
import api, { ResponseCallback } from '../services/api.service'

interface SearchResponseData {
  predictions: {
    description: string,
    'place_id': string
  }[]
}

export type SearchCallbackData = {
  address: string
  placeId: string
}[] | null

type AddressComponentType = 'street_number' | 'route' | 'locality' | 'administrative_area_level_1' | 'postal_code'

interface ReadResponseData {
  result: {
    'address_components': {
      'long_name': string,
      types: AddressComponentType[]
    }[]
  }
}

export type ReadCallbackData = {
  address: string
  city: string
  state: string
  zip: string
} | null

const routes = {
  search: '/googlePlaces/search',
  read: '/googlePlaces/read'
}

export default {
  search (address: string, callback: ResponseCallback<SearchCallbackData>) {
    const params = { address }
    api.get<SearchResponseData>(routes.search, params, (data) => {
      if (data) {
        const result = map(data.predictions, item => {
          const { description: address, place_id: placeId } = item
          return { address, placeId }
        })
        callback(result)
      } else callback(null)
    })
  },

  read (placeId: string, callback: ResponseCallback<ReadCallbackData>) {
    const params = { placeId }
    api.get<ReadResponseData>(routes.read, params, (data) => {
      if (data) {
        const addressComponents = data.result.address_components
        const getComponentName = (type: AddressComponentType) => {
          const component = find(addressComponents, component => {
            return includes(component.types, type)
          })
          return component ? component.long_name : ''
        }
        const streetNumber = getComponentName('street_number')
        const route = getComponentName('route')
        const address = `${streetNumber} ${route}`
        const city = getComponentName('locality')
        const state = getComponentName('administrative_area_level_1')
        const zip = getComponentName('postal_code')
        const result = { address, city, state, zip }
        callback(result)
      } else callback(null)
    })
  }
}
